import React from 'react';

export default ({type, children, position}) => (
	<span className={'Alert Alert--'+type+(position ? ' absolute' : '')}>{children}</span>
);